import { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";

import {
  CCheckbox,
  CInput,
  CNumber,
  CNumberInput,
  CSelect,
} from "src/common/components/controls";

export default ({ materialsOptions, materials, control, setValue }) => {
  //#region Data
  // const ignore = useMemo(
  //   () => data.filter((d) => d.code !== "").map((d) => d.code),
  //   [data]
  // );
  //#endregion

  //#region Event
  const handleSelectMaterial =
    (onChangeCallback, index) => (value, selectedOption) => {
      onChangeCallback(value);
      setValue(`materials.${index}.unit`, selectedOption?.unit);
      setValue(`materials.${index}.boughtUnit`, selectedOption?.boughtUnit);
      // setValue(`materials.${index}.max`, selectedOption?.max);
      setValue(
        `materials.${index}.boughtPrice`,
        selectedOption?.boughtPrice ?? 0
      );
    };
  //#endregion

  //#region Render
  return (
    <table className="table table-hover border c-table">
      <thead>
        <tr>
          <th
            style={{ width: "50px", paddingLeft: "20px", paddingRight: "24px" }}
          ></th>
          <th
            style={{ width: "auto", minWidth: "330px", paddingRight: "24px" }}
          >
            Mã NVL
          </th>
          <th
            style={{
              width: "auto",
              minWidth: "370px",
              paddingRight: "24px",
              textAlign: "left",
            }}
          >
            Tên NVL
          </th>
          <th
            style={{ width: "auto", minWidth: "150px", paddingRight: "24px" }}
          >
            ĐVT
          </th>
          {/* <th
            style={{ width: "auto", minWidth: "160px", paddingRight: "24px" }}
          >
            Số lượng tối đa
          </th> */}
          <th
            style={{
              width: "auto",
              minWidth: "110px",
              paddingRight: "24px",
              textAlign: "left",
            }}
          >
            Số lượng
          </th>
          <th
            style={{
              width: "auto",
              minWidth: "150px",
              paddingRight: "24px",
              textAlign: "right",
            }}
          >
            Thành tiền
          </th>
          <th
            style={{ width: "auto", minWidth: "150px", paddingRight: "24px" }}
          >
            Ghi chú
          </th>
        </tr>
      </thead>
      <tbody>
        {materials.map((material, index) => (
          <tr key={material.__id}>
            <td className="px-2">
              <Controller
                control={control}
                name={`materials.${index}.check`}
                render={({ field }) => <CCheckbox {...field} />}
              />
            </td>
            <td className="px-2">
              <Controller
                control={control}
                name={`materials.${index}.code`}
                render={({ field }) => (
                  <CSelect
                    options={materialsOptions}
                    display="code"
                    select="code"
                    disabled
                    {...field}
                  />
                )}
              />
            </td>
            <td className="px-2">
              <Controller
                control={control}
                name={`materials.${index}.code`}
                render={({ field: { onChange, ..._field } }) => (
                  <CSelect
                    className="text-left"
                    options={materialsOptions}
                    display="name"
                    select="code"
                    {..._field}
                    onChange={handleSelectMaterial(onChange, index)}
                  />
                )}
              />
            </td>
            <td className="px-2">
              <Controller
                control={control}
                name={`materials.${index}.code`}
                render={({ field }) => (
                  <CSelect
                    options={materialsOptions}
                    display="boughtUnit"
                    select="code"
                    disabled
                    {...field}
                  />
                )}
              />
            </td>
            <td className="px-2">
              <QuantityInput control={control} index={index} />
            </td>
            <td className="px-2">
              <TotalInput control={control} index={index} setValue={setValue} />
            </td>
            <td className="px-2">
              <Controller
                name={`materials.${index}.note`}
                control={control}
                render={({ field }) => (
                  <CInput {...field} placeholder="Nhập thông tin ghi chú" />
                )}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
  //#endregion
};

const QuantityInput = ({ control, index }) => {
  // const materialCode = useWatch({ control, name: `materials.${index}.code` });

  return (
    <Controller
      name={`materials.${index}.boughtQ`}
      control={control}
      render={({ field }) => (
        <CNumber
          isFloat
          //  disabled={!materialCode}
          {...field}
        />
      )}
    />
  );
};

const TotalInput = ({ control, index, setValue }) => {
  const boughtPrice = useWatch({
    control,
    name: `materials.${index}.boughtPrice`,
  });
  const boughtQ = useWatch({
    control,
    name: `materials.${index}.boughtQ`,
  });

  useEffect(() => {
    setValue(`materials.${index}.total`, (boughtPrice || 0) * (boughtQ || 0));
  }, [boughtPrice, boughtQ]);

  return (
    <Controller
      control={control}
      name={`materials.${index}.total`}
      render={({ field }) => (
        <CNumberInput className="text-right" disabled {...field} />
      )}
    />
  );
};
